import { Link } from "react-router-dom";
import { useT } from "@/i18n/I18nProvider";
import { SEO } from "@/components/common/SEO";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  const { t, path } = useT();
  return (
    <>
      <SEO routeKey="home" titleOverride={t.notFound.title} noindex />
      <section className="container-bnm min-h-[70vh] flex items-center py-24">
        <div>
          <p className="eyebrow mb-6">{t.notFound.eyebrow}</p>
          <h1 className="font-display font-light text-5xl md:text-7xl leading-tight tracking-tight text-ink">
            {t.notFound.title}
          </h1>
          <p className="mt-6 text-slate2 max-w-prose-tight text-lg">{t.notFound.body}</p>
          <Link
            to={path("home")}
            className="mt-10 inline-flex items-center gap-2 text-ink border-b border-ink pb-1 hover:text-clay hover:border-clay transition-colors"
            data-testid="notfound-home-link"
          >
            {t.notFound.action}
            <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </>
  );
}
